// constants/languages.js
export const SUPPORTED_LANGUAGES = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'German', value: 'de' },
  { label: 'Dutch', value: 'nl' },
  { label: 'Italian', value: 'it' },
  { label: 'French', value: 'fr' }
];
